/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9.618 11.032a5.5 5.5 0 111.414-1.414l3.97 3.969L13.586 15l-3.97-3.97zM10 6.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z" _fill="#002033" fill-opacity=".35"/>'
  }
})
